export default "__VITE_ASSET__243c58b7__"